import React, { useState } from "react";
import { DashType } from "@/features/dashboard";
import { QuestionCircleOutlined } from "@ant-design/icons/lib";
import { Modal, Tooltip } from "antd";
import { groupBy, round } from "lodash";
import { AgGridReact } from "ag-grid-react";
import { TitleCamelCase, TitleCase } from "@/utils/string";

type Props = {
  totalScore: DashType.BenchmarkScore;
  breakdown?: DashType.BenchmarkBreakdown;
};

export default ({ totalScore, breakdown }: Props) => {
  const [active, setActive] = useState(false);

  const title = breakdown
    ? `[${TitleCase(breakdown.investmentStyle)}] ${breakdown.group} Score Breakdown`
    : "No Breakdown";

  return (
    <>
      <Tooltip placement="bottomRight" title={"How score calculated?"}>
        <QuestionCircleOutlined onClick={() => setActive(true)} />
      </Tooltip>
      <Modal
        title={title}
        width={"75%"}
        visible={active}
        onCancel={() => setActive(false)}
        onOk={() => setActive(false)}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        {getBreakdown()}
      </Modal>
    </>
  );

  function getBreakdown() {
    if (breakdown) {
      const uniqueTicker = [
        ...new Set(
          totalScore.score
            .slice()
            .sort((a, b) => b.score - a.score)
            .map(e => e.ticker)
        )
      ];
      const columnDefs = [
        { headerName: "Metric", field: "metric", pinned: "left" },
        ...uniqueTicker.map(e => ({ headerName: e.toUpperCase(), field: e }))
      ];
      const firstRow = [
        {
          metric: "Total Score",
          ...totalScore.score.reduce((a, b) => ({ ...a, [b.ticker]: round(b.score, 2) }), {} as Record<string, number>)
        }
      ];
      const rowData = Object.entries(groupBy(breakdown.score, "metric")).map(([metric, data]) =>
        data.reduce((a, b) => ({ ...a, [b.ticker]: round(b.score, 2) }), {
          metric: metric.includes("_") ? TitleCamelCase(metric) : metric.toUpperCase()
        } as Record<string, string | number>)
      );

      return (
        <div
          className="ag-theme-alpine"
          style={{
            height: 20 + rowData.length * 20 + "px",
            width: "100%"
          }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={rowData}
            onGridReady={e => {
              e.api.setPinnedTopRowData(firstRow);
            }}
          />
        </div>
      );
    }

    return <p>Missing score breakdown...</p>;
  }
};
